// Opens the one "Connect print service" dialog from anywhere (settings, or a
// failed print's toast). The dialog itself is mounted once in App.
import { useCallback, useSyncExternalStore } from "react";

let open = false;
const listeners = new Set<() => void>();

function emit() {
  listeners.forEach((listener) => listener());
}

export function openTpsConnect(): void {
  open = true;
  emit();
}

export function closeTpsConnect(): void {
  open = false;
  emit();
}

export function isTpsConnectOpen(): boolean {
  return open;
}

export function subscribeTpsConnect(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** `[open, setOpen]` for the dialog host. */
export function useTpsConnectDialog(): [boolean, (next: boolean) => void] {
  const value = useSyncExternalStore(subscribeTpsConnect, isTpsConnectOpen, isTpsConnectOpen);
  const setOpen = useCallback((next: boolean) => (next ? openTpsConnect() : closeTpsConnect()), []);
  return [value, setOpen];
}
